module.exports = __webpack_public_path__ + "img/background07.bbc14bb1.jpg";